import vector from '../../../../images/vectorRight.png';
import tg from '../../../../images/telegramLogo.png';
import bacgroundFour from '../../../../images/bacgroundFour2.png';
import { useTranslation } from 'react-i18next';

const Talent = () => {
  const { t } = useTranslation();

  return (
    <section className="talent content-fix-index" id='vacancy'>
      <div className="talent__title">
        {t('tallentTitle', { returnObjects: true })[0]}<span>{t('tallentTitle', { returnObjects: true })[1]}</span>
      </div>

      <div className="talent__subtitle">
        {t('tallentSubTitle')}
      </div>

      <div className="talent__vacancy">
        <a href="https://t.me/nadiia_HR_bluff">
          <div className="talent__vacancy_buyer">
            {t('tallentVacancy')}
          </div>
        </a>
      </div>

      <div className="talent__buttons">
        <a href="https://t.me/nadiia_HR_bluff">
          <div className="talent__buttons_submit">{t('tallentButtonFirst')}</div>
        </a>
        <a href="https://t.me/nadiia_HR_bluff">
          <div className="talent__buttons_see">{t('tallentButtonSecond')}</div>
        </a>
      </div>

      <a href="https://t.me/nadiia_HR_bluff">
        <div className="talent__hr">
          <div className="talent__hr_title">{t('tallentHr')}</div>
          <div className="talent__hr_vector">
            <img alt="vector" src={vector}/>
          </div>
          <div className="talent__hr_tg">
            <img alt="tg" src={tg}/>
          </div>
        </div>
      </a>
      
      <img className='talent__bonusimg' alt='ima' src={bacgroundFour}/>
    </section>
  );
};

export default Talent;